"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
require("./Notification.css");
var Row_1 = require("../../components/Row");
var MDIcon_1 = require("../../components/MDIcon");
var classnames_1 = __importDefault(require("classnames"));
var iconSize = "1.3em";
var iconMap = {
  info: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
    size: iconSize,
    icon: "information-outline",
    className: "vsx-notification-icon info"
  }),
  success: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
    size: iconSize,
    icon: "checkbox-marked-circle-outline",
    className: "vsx-notification-icon success"
  }),
  warning: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
    size: iconSize,
    icon: "alert-circle-outline",
    className: "vsx-notification-icon warning"
  })
};
(0, MDIcon_1.preloadIcons)("checkbox-marked-circle-outline", "information-outline", "alert-circle-outline");
var Notification = function (_a) {
  var _b = _a.type,
    type = _b === void 0 ? "info" : _b,
    _c = _a.shadow,
    shadow = _c === void 0 ? "none" : _c,
    _d = _a.inline,
    inline = _d === void 0 ? false : _d,
    className = _a.className,
    border = _a.border,
    minWidth = _a.contentMinWidth,
    maxWidth = _a.contentMaxWidth,
    contentStyle = _a.contentStyle,
    children = _a.children,
    dismissible = _a.dismissible,
    onDismiss = _a.onDismiss,
    style = _a.style,
    restProps = __rest(_a, ["type", "shadow", "inline", "className", "border", "contentMinWidth", "contentMaxWidth", "contentStyle", "children", "dismissible", "onDismiss", "style"]);
  var cn = (0, classnames_1.default)("vsx-notification", "vsx-notification-shadow-".concat(shadow), border && "vsx-notification-border", className);
  var dismissIcon = dismissible ? (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, {
    size: iconSize,
    icon: "close",
    role: "button",
    className: "vsx-notification-dismiss-icon",
    onClick: function () {
      return onDismiss && onDismiss();
    }
  }) : null;
  return (0, jsx_runtime_1.jsxs)(Row_1.Row, __assign({
    className: cn,
    padding: "medium-large",
    align: "start",
    gap: "medium",
    inline: inline,
    style: style
  }, restProps, {
    children: [iconMap[type], (0, jsx_runtime_1.jsx)("span", __assign({
      className: "vsx-notification-children",
      style: __assign({}, contentStyle)
    }, {
      children: children
    })), dismissIcon]
  }));
};
exports.Notification = Notification;